export const getLineChartSymbol = index => {
  const symbols = ['circle', 'square', 'triangle', 'diamond', 'triangle-down'];
  return symbols[index % symbols.length];
};

export const underscoreToText = (str = '') => {
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
